export default __webpack_public_path__ + "images/1bbe26aaee72b122f5408d643cb5dbcf-classical_music_small.webp";